<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="invoices"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="invoiceNumber" width="150"></dxi-column>
            <dxi-column dataField="pONumber" width="150"></dxi-column>
            <dxi-column dataField="job.jobNumber" caption="Job #" width="150"></dxi-column>
            <dxi-column dataField="job.customerName" caption="Customer" width="150"></dxi-column>

            <dxi-column dataField="job.cellPhone" caption="Cell"></dxi-column>
            <dxi-column dataField="job.email" caption="Email" width="200"></dxi-column>
            <dxi-column dataField="emailed" caption="Email Date" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="mailed" caption="Mailed" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="linesTotal" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="created" caption="Create Date" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="paid" caption="Paid Date" type="date" width="100"></dxi-column>
            <dxi-column dataField="paidBoolean" caption="Paid" type="date" width="100"></dxi-column>
            <dxi-column dataField="invoiceAge" width="100"></dxi-column>
            <dxi-column dataField="isMailed" caption ="Mailed" width="100"></dxi-column>

            <dxo-summary>
                <dxi-total-item column="linesTotal" summaryType="sum"  [valueFormat]="{ type: 'currency', precision: 2 }" displayFormat="Total: {0}" > </dxi-total-item>
            </dxo-summary>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="employee-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" class="btn btn-success">Open</button>
                <button type="button" (click)="open()" class="btn btn-secondary ml-2">New</button>
                <button type="button" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="markAsPaid()" class="btn btn-secondary ml-2">Mark As Paid</button>
                <button type="button" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="mailed()" class="btn btn-secondary ml-2">Mailed</button>
                <button type="button" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="delete()" class="btn btn-sm btn-danger ml-3">Delete</button>
                <button type="button" class="btn btn-sm btn-warning ml-3" (click)="toggleShowAll()">{{showAll ? 'Show Recent' : 'Show All'}}</button>

            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="invoices" class="mr-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
